import { useCallback, useEffect, useState } from 'react';
import { actualizarProyeccion, getProyeccion } from '../../../api';
import toast from '../../../toast';
import { fmtCorte } from './proyeccionUtils';

/** Carga la proyección de un mes y expone el botón "Actualizar". */
export default function useProyeccion(anio, mes) {
  const [data, setData]               = useState(null);
  const [loading, setLoading]         = useState(true);
  const [actualizando, setActualizando] = useState(false);

  const params = anio && mes ? { anio, mes } : {};

  const cargar = useCallback(() => {
    setLoading(true);
    return getProyeccion(anio && mes ? { anio, mes } : {})
      .then(({ data }) => setData(data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [anio, mes]);

  useEffect(() => { cargar(); }, [cargar]);

  const actualizar = () => {
    setActualizando(true);
    actualizarProyeccion(params)
      .then(({ data: r }) => {
        setData(r.proyeccion);
        if (r.actualizado) toast.success('Proyección actualizada.');
        else toast.success(`Ya tenés el último dato (corte ${fmtCorte(r.proyeccion?.corte)}). La hoja se renueva cada 10 minutos.`);
      })
      .catch((err) => {
        // 409: la hoja se estaba reescribiendo. Los 5xx/403 ya los toastea el interceptor.
        if (err.response?.status === 409) toast.warning(err.response.data?.error || 'La hoja se está actualizando, probá en un par de minutos.');
      })
      .finally(() => setActualizando(false));
  };

  return { data, loading, actualizando, actualizar, recargar: cargar };
}
